import { LeftOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import { useNavigate, useLocation } from 'react-router-dom';

const uuidRegex =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/u;

const backLocationName = (upOneLocation: string) => {
  if (upOneLocation === '') {
    return 'home';
  }
  if (uuidRegex.test(upOneLocation)) {
    return 'roster';
  }
  return upOneLocation;
};

/**
 * @returns A styled button that goes back one page in the browser history, or back to the specific 'to' link (within the app route).
 */
const BackButton = () => {
  const navigate = useNavigate();

  const location = useLocation();

  const upOneLocation: string = location.pathname
    .split('/')
    .filter((pathElement) => pathElement.length > 0)
    .slice(-2, -1)
    .join();

  const convertedLocation: string = backLocationName(upOneLocation);

  const onGoBack = () => {
    const upperHierarchyLocation = `${location.pathname
      .split('/')
      .slice(0, -1)
      .join('/')}`;

    return navigate(
      upperHierarchyLocation.length === 0 ? '/' : upperHierarchyLocation,
      { replace: true }
    );
  };

  return (
    <Button
      id="go-back-button"
      style={{ textTransform: 'capitalize' }}
      onClick={onGoBack}
      icon={<LeftOutlined />}
    >
      {convertedLocation === 'teams' ? 'all teams' : convertedLocation}
    </Button>
  );
};

export default BackButton;
